import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Stack,
  Pagination,
  Button,
} from "@mui/material";
import Breadcrumb from "../../DefaultComponent/BreadCrumb";
import Spinner from "../../DefaultComponent/Spinner";
import ToastDefault from "../../DefaultComponent/Toast";
import { formatDate, calculateTotalPages } from "../../../utils/Helper";
import {
  JobListAction,
  JobCreateAction,
} from "../../../Redux/Actions/CareerAction";
import CreateJobForm, { JobCreate } from "./CreateJob/CreateJob";
import JobDetail from "./JobDetail/JobDetail";
import { useNavigate } from "react-router-dom";

export interface Job {
  id: number;
  title: string;
  meta_data: string;
  company_description: string;
  role_description: string;
  location: string;
  salary: string;
}

const Jobs: React.FC = () => {
  const dispatch = useDispatch<any>();
  const jobData = useSelector((state: any) => state.JobListData);

  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage] = useState<number>(10);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const navigate = useNavigate();

  const fetchJobs = (pageNum: number = page) => {
    setLoading(true);
    const params = `?page=${pageNum}&page_size=${rowsPerPage}`;
    dispatch(JobListAction(params)).finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchJobs();
  }, [dispatch, page]);

  useEffect(() => {
    if (jobData?.data?.results) {
      setJobs(jobData.data.results);
    }
  }, [jobData]);

  const handleCreate = (data: JobCreate) => {
    dispatch(JobCreateAction(data)).then(() => {
      fetchJobs(1);
    });
    setOpenForm(false);
  };

  return (
    <>
      {loading && <Spinner />}
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="col-md-12">
          <Breadcrumb
            pageTitle="Jobs"
            breadcrumbs={[{ label: "Jobs", path: "/jobs", isActive: true }]}
          />
        </div>

        <Box sx={{ m: 2, display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenForm(true)}
          >
            Create Job
          </Button>
        </Box>

        <Box sx={{ m: 2, overflowX: "auto" }}>
          <TableContainer component={Paper} sx={{ minWidth: 800 }}>
            <Table aria-label="Jobs Table">
              <TableHead sx={{ backgroundColor: "#0555c8" }}>
                <TableRow>
                  <TableCell sx={{ color: "white" }}>S.No</TableCell>
                  <TableCell sx={{ color: "white" }}>Title</TableCell>
                  <TableCell sx={{ color: "white" }}>Summary</TableCell>
                  <TableCell sx={{ color: "white" }}>Company</TableCell>
                  <TableCell sx={{ color: "white" }}>Role</TableCell>
                  <TableCell sx={{ color: "white" }}>Location</TableCell>
                  <TableCell sx={{ color: "white" }}>Salary</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {jobs.length > 0 ? (
                  jobs.map((job, idx) => (
                    <TableRow
                      key={job.id}
                      hover
                      sx={{ cursor: "pointer" }}
                      onClick={() => navigate(`/jobs/${job.id}`)}
                    >
                      <TableCell>
                        {(page - 1) * rowsPerPage + idx + 1}
                      </TableCell>
                      <TableCell>{job.title}</TableCell>
                      <TableCell>{job.meta_data}</TableCell>
                      <TableCell>{job.company_description}</TableCell>
                      <TableCell>{job.role_description}</TableCell>
                      <TableCell>{job.location}</TableCell>
                      <TableCell>{job.salary}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Jobs Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <div className="pagination-style">
          <Stack spacing={2}>
            <Pagination
              count={calculateTotalPages(
                jobData?.data?.total_count || 0,
                rowsPerPage
              )}
              page={page}
              onChange={(e: any, newPage) => setPage(newPage)}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>
      </div>
      <ToastDefault />

      <CreateJobForm
        open={openForm}
        onClose={() => setOpenForm(false)}
        onSubmit={handleCreate}
      />
    </>
  );
};

export default Jobs;
